import $ from "jquery";
import App from "../src/App";
import { Swiper } from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss/effect-fade";

$(".js-hero-slider").each(function () {
  const $hero = $(this);
  const $swiperEl = $hero.find(".swiper");
  const paginationEl = $hero.find(".swiper-pagination")[0];

  // Initialize Swiper
  const swiper = new Swiper($swiperEl[0], {
    modules: [Navigation, Pagination, EffectFade],
    effect: "fade",
    slidesPerView: 1,
    autoplay: false,
    loop: false,
    speed: 1200,
    navigation: {
      prevEl: $hero.find(".hero-navigation__button--prev")[0],
      nextEl: $hero.find(".hero-navigation__button--next")[0],
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
  });

  // Manually trigger initialization
  swiper.emit("init");
});

$(".js-anchors").each(function () {
  const $anchors = $(this);
  const $swiperEl = $anchors.find(".swiper");

  // Initialize Swiper for anchors
  const swiper = new Swiper($swiperEl[0], {
    slidesPerView: "auto",
    loop: false,
  });

  // Manually trigger initialization
  swiper.emit("init");

  // Handle active state for anchor links
  $anchors.on("click", ".anchor-links__item", function (e) {
    // Remove active class from all anchor links
    $(".anchor-links__item").removeClass("active");

    // Add active class to clicked anchor link
    $(this).addClass("active");
  });
});

$(".js-thematic-slider").each(function () {
  const $subsection = $(this);

  function updateNavTitles(swiper) {
    // Get current active slide index
    const activeIndex = swiper.activeIndex;
    const activeSlide = swiper.slides[activeIndex];
    const activeSlideTitle = $(activeSlide).find(".thematic-subsection__title").text();
    const $currentTitle = $subsection.find(".thematic-slider__current-title");

    $currentTitle.text(activeSlideTitle);
  }

  const swiper = new Swiper($subsection.find(".swiper")[0], {
    modules: [Navigation, EffectFade],
    effect: "fade",
    slidesPerView: 1,
    autoplay: false,
    loop: true,
    speed: 600,
    spaceBetween: 30,
    autoHeight: true,
    navigation: {
      prevEl: $subsection.find(".thematic-slider__button--prev")[0],
      nextEl: $subsection.find(".thematic-slider__button--next")[0],
    },
    on: {
      init: function () {
        updateNavTitles(this);
      },
      slideChange: function () {
        updateNavTitles(this);
      },
    },
  });
});

const applyReadMore = () => {
  $(".js-readmore-container").each(function () {
    const $container = $(this);
    const $paragraphs = $container.find("p");
    const $toggle = $container.find(".js-readmore-toggle");

    // Skip if already applied
    if ($container.data("readmore-applied")) return;

    // Dynamic character limit based on screen width
    let charLimit = 663;
    if (window.innerWidth < 1440) {
      charLimit = 480;
    }

    let visibleChars = 0;
    const $hiddenWrapper = $('<div class="js-readmore-extra" style="display: none;"></div>');

    $paragraphs.each(function () {
      const $p = $(this);
      const textLength = $p.text().length;

      if (visibleChars + textLength <= charLimit) {
        visibleChars += textLength;
      } else {
        $hiddenWrapper.append($p);
      }
    });

    if ($hiddenWrapper.children().length > 0) {
      $container.append($hiddenWrapper);
      $container.append($toggle);
      $container.addClass("is-truncated");
      $toggle.text("Read more").removeClass("hidden");
      $container.data("readmore-applied", true); // Prevent double init

      $toggle.on("click", function (e) {
        e.preventDefault();
        const isVisible = $hiddenWrapper.is(":visible");

        $hiddenWrapper.slideToggle();
        $toggle.text(isVisible ? "Read more" : "Read less");
      });
    }
  });
};

const removeReadMore = () => {
  $(".js-readmore-container").each(function () {
    const $container = $(this);

    if (!$container.data("readmore-applied")) return;

    const $extra = $container.find(".js-readmore-extra");
    const $toggle = $container.find(".js-readmore-toggle");

    // Move hidden paragraphs back
    $extra.children().insertBefore($toggle);
    $extra.remove();
    $toggle.addClass("hidden").off("click").text("Read more");
    $container.removeClass("is-truncated").removeData("readmore-applied");
  });
};

// Set up media query listener
const mediaQuery = window.matchMedia("(min-width: 992px)");
const width1440Query = window.matchMedia("(min-width: 1440px)");
const handleResize = (e) => {
  if (e.matches) {
    applyReadMore();
  } else {
    removeReadMore();
  }
};

// Initial check
if (mediaQuery.matches) {
  applyReadMore();
} else {
  removeReadMore();
}
const reapplyReadMore = () => {
  // Only run if screen is large enough for read more
  if (mediaQuery.matches) {
    removeReadMore();
    applyReadMore();
  }
};

mediaQuery.addEventListener("change", handleResize);
width1440Query.addEventListener("change", reapplyReadMore);
